"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);
import SimpleBar from "simplebar";
import { setUpAccordion } from "./_accordion";
import Swiper, { Navigation, Pagination, Autoplay } from "swiper/swiper-bundle";
Swiper.use([Navigation, Pagination, Autoplay]);
function interviewKvAnim() {
  const kvTl = gsap.timeline();
  // const kvLogo = document.querySelector(".kv-icon");
  const kvCatch = document.querySelector(".kv-catch");
  const kvCopy = document.querySelector(".kv-copy");
  const kvShip = document.querySelector(".kv-ship");
  kvTl
    // .add(() => {
    //   kvLogo.classList.add("is-active");
    // })
    .add(() => {
      kvCatch.classList.add("is-active");
    }, "1")
    .add(() => {
      kvShip.classList.add("is-active");
    })
    .add(() => {
      kvCopy.classList.add("is-active");
    });
}

let contentSwiperOption = {
  initialSlide: 0,
  // autoHeight: true,
  // allowTouchMove: true,
  autoplay: {
    delay: 5000,
    // disableOnInteraction: false, // ユーザが操作しても自動再生を継続させる
  },
  // modules: [Navigation],
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    clickable: true,
    el: ".swiper-pagination",
    renderBullet: function (index, className) {
      return '<span class="' + className + '">0' + (index + 1) + "</span>";
    },
  },
  slidesPerView: 1,
  loop: true,
  centeredSlides: true,
  speed: 1000,
};
function entyrSwiper() {
  let entyrSwiper = new Swiper(".entry-slide-swiper", contentSwiperOption);
}
function cuntUp() {
  var countUpTrigger = document.querySelector(".js-countUp-trigger");
  var countUpTarget = document.querySelector(".js-countUp-target");
  var elementDic = {
    from: countUpTarget.dataset.from,
    to: countUpTarget.dataset.to,
  };
  var elementNum = { count: elementDic.from };
  gsap.to(elementNum, {
    count: elementDic.to,
    duration: 2,
    ease: "none",
    scrollTrigger: {
      trigger: countUpTrigger,
      start: "top center",
    },
    onUpdate: () => {
      countUpTarget.textContent = Math.floor(elementNum.count).toLocaleString();
    },
  });
}
window.addEventListener("DOMContentLoaded", () => {
  interviewKvAnim();
  setUpAccordion();
  // new SimpleBar(document.querySelector(".campaign-terms-content"), {
  //   autoHide: false,
  // });
  // entyrSwiper();
  // cuntUp();
});
